var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.items, function (item) {
      return ((_vm.userInfo.mobile != item.mobile && _vm.showSelectedStatus) ||
        !_vm.showSelectedStatus) &&
        (!_vm.value ||
          (_vm.value && item.nickName && item.nickName.includes(_vm.value)) ||
          (item.mobile && item.mobile.includes(_vm.value)))
        ? _c(
            "li",
            {
              key: item.logInId,
              staticClass:
                "d-table w-100-p b-b b-c-g-100 cursor-default bg-g-50-hover",
              on: {
                click: function ($event) {
                  !_vm.showSelectedStatus && _vm.itemClickEvent(item)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover p-relative",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-table-cell v-a-middle h-100-p w-64",
                      staticStyle: { "text-align": "center" },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none",
                          staticStyle: { "background-color": "#653EB3" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.getShortNickname(item.nickName || item.mobile)
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "d-table-cell v-a-middle h-100-p" },
                    [
                      _c("div", { style: { width: _vm.listWidth + "px" } }, [
                        _c(
                          "p",
                          { staticClass: "t-ellipsis l-h-1-6-em m-r-10" },
                          [_vm._v(_vm._s(item.nickName))]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-500",
                          },
                          [_vm._v(_vm._s(item.mobile))]
                        ),
                      ]),
                    ]
                  ),
                  _vm.showSelectedStatus
                    ? [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedSessionsID,
                              expression: "selectedSessionsID",
                            },
                          ],
                          staticClass:
                            "p-absolute top-0 right-0 bottom-0 left-0 o-0 w-100-p h-100-p",
                          attrs: { name: "Fruit", type: "checkbox" },
                          domProps: {
                            value: item.logInId,
                            checked: Array.isArray(_vm.selectedSessionsID)
                              ? _vm._i(_vm.selectedSessionsID, item.logInId) >
                                -1
                              : _vm.selectedSessionsID,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.selectedSessionsID,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = item.logInId,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedSessionsID = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedSessionsID = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedSessionsID = $$c
                                }
                              },
                              function ($event) {
                                return _vm.onSelectedSessionChange(item)
                              },
                            ],
                          },
                        }),
                        _vm.selectedSessionsID.includes(item.logInId)
                          ? _c("i", { staticClass: "d-inline-block m-t-22" }, [
                              _c("img", {
                                staticStyle: { width: "22px", height: "22px" },
                                attrs: {
                                  src: require("@/assets/images/im/selectedSession@2x.png"),
                                },
                              }),
                            ])
                          : _c("i", { staticClass: "d-inline-block m-t-22" }, [
                              _c("img", {
                                staticStyle: { width: "22px", height: "22px" },
                                attrs: {
                                  src: require("@/assets/images/im/unSelectedSession@2x.png"),
                                },
                              }),
                            ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }